module.exports = __webpack_public_path__ + "media/images/lp/icn_check-6cd6d126628b437fecd904c38ae4f309.svg";